import { useLocation } from "react-router-dom";

/**
 * Gates partner admin routes using Django-injected flag (same pattern as gratis admin).
 * API access is still enforced by IsPartnerProgramAdmin on the backend.
 */
export default function AdminRouteGuard({ children }) {
  const location = useLocation();
  const canAccess =
    window.MNF_IS_PARTNER_ADMIN === true ||
    window.MNF_IS_PARTNER_ADMIN === "true" ||
    window.MNF_CAN_ACCESS_PARTNER_ADMIN === true ||
    window.MNF_CAN_ACCESS_PARTNER_ADMIN === "true";

  if (!canAccess) {
    const next = encodeURIComponent(
      `${location.pathname}${location.search}${location.hash}`
    );
    window.location.href = `/personal-login/?next=${next}`;
    return null;
  }

  return children;
}
